import React, { useEffect, useRef, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Alert, Card, Row, Col, Button, Tab, Tabs, Image } from 'react-bootstrap';
import { getToken } from 'actions';
import { Page, Terminal } from 'components';
import Header from '../../../../components/Header/Header';
import Api from 'services/Api';

const wsUrl = process.env.REACT_APP_API_MONITORA.replace('https', 'wss').replace('http', 'ws');
const refreshRate = 15000;
const throttleTime = 100;

const ConectedOrange = (props) => {

  const history = useHistory();

  const requestRef = useRef(null); // raf de vídeo
  const mouseMoveRafRef = useRef(null); // raf do mousemove
  const imageRef = useRef(null);
  const prevImageUrlRef = useRef(null);
  const socketRef = useRef(null);
  const lastSendTimeRef = useRef(0);
  const reconnectAttemptsRef = useRef(0);
  const reconnectTimeoutRef = useRef(null);
  const pingIntervalRef = useRef(null);
  const isVisibleRef = useRef(!document.hidden);
  const rafScheduledRef = useRef(false); // controla apenas 1 RAF por vez
  const latestFrameRef = useRef(null); // mantém o último frame recebido
  const serialNumber = useParams().id;

  const user = JSON.parse(localStorage.getItem('userData'));
  const supportOrangePermission =
    user?.permission?.supportOrange ||
    user?.permission?.remoteaccess ||
    { read: false, write: false };

  if (
    user?.permission?.supportOrange?.read !== true &&
    user?.permission?.remoteaccess?.read !== true
  ) {
    window.location.replace('/home')
  }

  const [imageSrc, setImageSrc] = useState('');
  const [errors, setErrors] = useState([]);
  const [streamInternalCam, setStreamInternalCam] = useState(false);
  const [imageCamSrc, setImageCamSrc] = useState('');
  const [connectionStabished, setConnectionStabished] = useState(false)
  const [inputValueAlert, setInputValueAlert] = useState('');
  const [response, setResponse] = useState('Console\n');
  const [isHovered, setIsHovered] = useState(false);
  const [widthRatio, setWidthRatio] = useState(1);
  const [heightRatio, setHeigthRatio] = useState(1);

  const [equipConfig, setEquipConfig] = useState({
    'serial': '--',
    'webcam': false,
    'freq_v': '--',
    'serv_e': '--',
    'serv_m': '--',
    'serv_d': '--',
    'calib_id': '--',
    'calib': '--',
    'eixo_x': '--',
    'eixo_y': '--',
    'eixo_z': '--',
    'v_firmware': '--',
    'v_firmware_osc': '--',
    'activation_date': '--',
    'activation_days': '--',
    'volume_corr_densidade': '--',
    'densidade_esfera': '--',
    'offset_bal1': '--',
    'offset_bal2': '--',
    'cross_check': '--',
    'sw': '--',
    'sws': '--'
  })

  const canSend = () => socketRef.current && socketRef.current.readyState === WebSocket.OPEN;

  const handleSubmit = (inputValue) => {
    if (!connectionStabished || !canSend()) return;

    const command = {
      type: 'message',
      room: serialNumber,
      content: {
        command: 'process',
        parameters: {
          command: inputValue
        }
      }
    };
    socketRef.current.send(JSON.stringify(command));
  };

  const handleSubmitAlert = (event) => {
    if (!inputValueAlert || !connectionStabished || !canSend()) return;

    event.preventDefault();
    const command = {
      type: 'alert',
      room: serialNumber,
      msg: inputValueAlert
    };
    socketRef.current.send(JSON.stringify(command));

    setInputValueAlert('');
  };

  const base64ToBlob = (base64, mime = 'image/png') => {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  };

  // Coalescer frames: mantém apenas um RAF e usa o último frame recebido
  const scheduleFrameRender = () => {
    if (rafScheduledRef.current) return;
    rafScheduledRef.current = true;
    requestRef.current = requestAnimationFrame(() => {
      rafScheduledRef.current = false;
      const imgData = latestFrameRef.current;
      if (!imgData) return;
      try {
        const blob = base64ToBlob(imgData, 'image/png');
        if (prevImageUrlRef.current) {
          URL.revokeObjectURL(prevImageUrlRef.current);
        }
        const objectUrl = URL.createObjectURL(blob);
        prevImageUrlRef.current = objectUrl;
        setImageSrc(objectUrl);
      } catch (err) {
        setImageSrc(`data:image/png;base64,${imgData}`);
      }
    });
  };

  // Update width/height ratio based on actual image natural size vs displayed size
  const handleImageLoad = (e) => {
    const img = e.target;
    if (!img) return;
    const rect = img.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      setWidthRatio(img.naturalWidth / rect.width);
      setHeigthRatio(img.naturalHeight / rect.height);
    }
  };

  const setupSocketHandlers = () => {
    const socket = socketRef.current;
    if (!socket) return;

    pingIntervalRef.current = setInterval(() => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ type: 'ping' }));
      }
    }, 20000);

    socket.onopen = () => {
      reconnectAttemptsRef.current = 0;
      setConnectionStabished(true);
    };

    socket.onmessage = (event) => {
      const data = event.data;
      let json_msg = JSON.parse(data);

      if (json_msg.type === "invalid_user") {
        if (json_msg?.msg) {
          alert(json_msg?.msg);
        } else {
          alert("Sem permissão!");
        }
        handleDisconnect();
      }

      if (json_msg.type === "valid_user") {
        setConnectionStabished(true);
        handleLoadData();
      }

      if (json_msg.type === "desconnect") {
        setConnectionStabished(false);
      }

      if (json_msg.type === "connected") {
        console.log('connected');

        setConnectionStabished(true);
        handleLoadData();
      }

      if (json_msg.pubkey) {
        socket.send(
          JSON.stringify({
            type: 'join',
            room: serialNumber,
            user_id: user?._id,
            name: user?.name,
            email: user?.email,
            client: 'client',
            page: 'supportOrange',
            token: getToken(),
            content: {
              name: `${user.email}-API-SUPORTE-ORANGE`
            },
          }));

      } else {
        if (json_msg?.content?.img) {
          // Se a aba estiver oculta, apenas guarda o último frame; renderiza ao voltar
          latestFrameRef.current = json_msg.content.img;
          if (isVisibleRef.current) {
            scheduleFrameRender();
          }
          return;
        }

        if (json_msg?.content?.text) {
          // coalescer texto também para evitar burst ao voltar
          if (isVisibleRef.current) {
            requestAnimationFrame(() => {
              setResponse(json_msg.content.text);
            });
          }
          return;
        }

        if (json_msg?.content?.img_cam) {
          requestAnimationFrame(() => {
            setImageCamSrc(`data:image/png;base64,${json_msg.content.img_cam}`);
          });
          return;
        }

        if (json_msg?.content?.network_config) {
          // setNetworkConfig(json_msg.content.network_config);
          return;
        }

        if (json_msg?.content?.equip_config) {
          requestAnimationFrame(() => {
            setEquipConfig(json_msg.content.equip_config);
          });
          return;
        }
      }
    };

    socket.onclose = () => {
      if (pingIntervalRef.current) {
        clearInterval(pingIntervalRef.current);
        pingIntervalRef.current = null;
      }
      setConnectionStabished(false);
      // tenta reconectar com backoff, exceto se desmontado
      const attempt = reconnectAttemptsRef.current + 1;
      reconnectAttemptsRef.current = attempt;
      const delay = Math.min(30000, 1000 * Math.pow(2, Math.min(6, attempt))); // 1s,2s,4s... máx 30s
      if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = setTimeout(() => {
        if (isVisibleRef.current) {
          handleConnect();
        } else {
          // aguardará até voltar a ficar visível
        }
      }, delay);
    };
  };

  const handleConnect = () => {
    try {
      socketRef.current = new WebSocket(wsUrl);
      setupSocketHandlers();
    } catch (e) {
      // agenda nova tentativa se falhar
      if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = setTimeout(() => handleConnect(), 3000);
    }
  };

  const handleLoadData = () => {
    if (!canSend()) return;
    socketRef.current.send(
      JSON.stringify({
        type: 'message',
        room: serialNumber,
        content: {
          command: 'load_data',
          parameters: {}
        },
      })
    );

    socketRef.current.send(
      JSON.stringify({
        type: 'connect_support',
        room: serialNumber,
        hidden: user.master ? user.master : false
      })
    );
  }

  const handleImageClick = (event) => {
    if (!connectionStabished || !canSend()) return;

    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    socketRef.current.send(
      JSON.stringify({
        type: 'message',
        room: serialNumber,
        content: {
          command: 'click',
          parameters: {
            x: x,
            y: y
          }
        }
      })
    );
  };

  const handleRightClick = (event) => {
    if (!connectionStabished || !canSend()) return;
    event.preventDefault();

    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    socketRef.current.send(
      JSON.stringify({
        type: 'message',
        room: serialNumber,
        content: {
          command: 'clickRight',
          parameters: {
            x: x,
            y: y
          }
        }
      })
    );

  };

  const handleMouseEnter = () => {
    setIsHovered(true)
  };
  const handleMouseLeave = () => {
    setIsHovered(false)
  };

  const calculateCoordinates = (event, rect) => {
    const offsetX = event.clientX - rect.left;
    const offsetY = event.clientY - rect.top;

    const x = offsetX * widthRatio;
    const y = offsetY * heightRatio;

    return { x, y };
  };

  const handleMouseMove = (e) => {
    if (!canSend()) return;
    const rect = e.target.getBoundingClientRect();
    const { x, y } = calculateCoordinates(e.nativeEvent, rect);

    if (mouseMoveRafRef.current) {
      cancelAnimationFrame(mouseMoveRafRef.current);
      mouseMoveRafRef.current = null;
    }

    mouseMoveRafRef.current = requestAnimationFrame(() => {
      const currentTime = Date.now();
      if (currentTime - lastSendTimeRef.current > throttleTime) {
        socketRef.current.send(
          JSON.stringify({
            type: 'message',
            room: serialNumber,
            content: {
              command: 'move',
              parameters: {
                x,
                y
              }
            }
          })
        );
        lastSendTimeRef.current = currentTime;
      }
    });
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (!isHovered) return;

      const keyCombination = [];

      if (event.ctrlKey) keyCombination.push('Ctrl');
      if (event.altKey) keyCombination.push('Alt');
      if (event.shiftKey) keyCombination.push('Shift');
      if (event.metaKey) keyCombination.push('Meta');

      let key = event.key;

      if (key.length !== 1) {
        key = event.code;
      }

      keyCombination.push(key);
      const combination = keyCombination.join('+');

      if (event.ctrlKey && ['s', 'a', 'p', 'f', 'o'].includes(event.key.toLowerCase())) {
        event.preventDefault(); // Impede o comportamento padrão de Ctrl+S, Ctrl+A, Ctrl+P, etc.
      }

      if (!canSend()) return;
      socketRef.current.send(
        JSON.stringify({
          type: 'message',
          room: serialNumber,
          content: {
            command: 'keypress',
            parameters: {
              key: combination
            }
          }
        })
      );
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [connectionStabished, isHovered]);

  const sendGetScreen = () => {
    if (canSend()) {
      socketRef.current.send(
        JSON.stringify({
          type: 'connect_support',
          room: serialNumber,
          stream_internal_cam: streamInternalCam,
          hidden: user.master ? user.master : false
        })
      );
    }
  };

  useEffect(() => {
    const interval1 = setInterval(() => {
      sendGetScreen();
    }, refreshRate);
    return () => {
      clearInterval(interval1);
    };
  }, [streamInternalCam]);

  // Função para desconectar o WebSocket
  const handleDisconnect = () => {
    if (canSend()) {
      socketRef.current.send(
        JSON.stringify({
          type: 'desconnect_support',
          room: serialNumber
        })
      );
      socketRef.current.close();
      setConnectionStabished(false);
    }
    history.push('/remote-access');
  };

  const handleGetErrors = async () => {
    try {
      const { data } = await Api.get('/troubles/list-equipment', { params: { serial: serialNumber } });
      setErrors(data);
    } catch (error) {
      console.log(error?.message);
    }
  }

  useEffect(() => {
    // handleGetErrors();
  }, []);

  useEffect(() => {
    handleConnect();
    const onVisibilityChange = () => {
      const visible = !document.hidden;
      isVisibleRef.current = visible;
      // ao ficar visível, renderiza último frame e reenvia get screen
      if (visible) {
        if (latestFrameRef.current) scheduleFrameRender();
        sendGetScreen();
        // Se o socket caiu enquanto oculto, tenta reconectar
        if (!canSend()) {
          handleConnect();
        }
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (socketRef.current) socketRef.current.close();
      // cleanup animation frame
      if (requestRef.current) {
        cancelAnimationFrame(requestRef.current);
      }
      if (mouseMoveRafRef.current) {
        cancelAnimationFrame(mouseMoveRafRef.current);
      }
      // revoke last object url to avoid memory leak
      if (prevImageUrlRef.current) {
        URL.revokeObjectURL(prevImageUrlRef.current);
      }
      if (pingIntervalRef.current) {
        clearInterval(pingIntervalRef.current);
      }
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Page className="p-3" title="Suporte Orange">
      <Header page={"Suporte Orange"} handleDisconnect={handleDisconnect} />

      <Card className='mb-2 mt-2 p-2'>
        <Row className='g-2'>
          <Col>
            {connectionStabished ?
              <Alert variant="success" className='mt-1 mb-1 p-2'>
                <p style={{ marginBottom: 0 }}>
                  Conectado
                </p>
              </Alert>
              :
              <Alert variant="danger" className='mt-1 mb-1 p-2'>
                <p style={{ marginBottom: 0 }}>
                  Desconectado
                </p>
              </Alert>
            }
          </Col>
          <Col className='d-flex justify-content-end align-items-center'>
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => { handleDisconnect() }}
            >
              Desconectar
            </Button>
          </Col>
        </Row>
      </Card>

      <Card className='mb-2 p-2'>
        <Row className='g-2'>
          <Col>
            <div>
              {!imageSrc ? (
                <span style={{ color: 'black' }}>
                  Aguardando imagem...
                </span>
              ) : (
                <Image
                  onClick={handleImageClick}
                  onContextMenu={handleRightClick}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  onMouseMove={handleMouseMove}
                  onLoad={handleImageLoad}
                  ref={imageRef}
                  src={imageSrc}
                  style={{
                    minWidth: 800,
                    minHeight: 480,
                    maxWidth: 1280,
                    maxHeight: 720,
                    objectFit: 'cover',
                    cursor: connectionStabished ? 'pointer' : 'none',
                    opacity: connectionStabished ? 1 : 0.7,
                    filter: connectionStabished ? 'none' : 'grayscale(100%)',
                    borderRadius: '5px', // Arredondar a borda da imagem
                    border: '3px solid grey', // Contorno sutil da imagem
                  }}
                />
              )}
            </div>
          </Col>

          <Col>
            <div style={{ height: 480, maxWidth: 800 }}>
              <Tabs defaultActiveKey="1" id="fill-tab-example" fill>

                {/* Aba do Terminal */}
                <Tab eventKey="1" title="Terminal">
                  <div style={{ height: 440, overflowY: "auto" }}>
                    <Terminal
                      onCommandSubmit={handleSubmit}
                      response={response}
                      connectionStabished={connectionStabished}
                      permission={supportOrangePermission?.write}
                    />
                  </div>
                </Tab>

                {/* Aba dos Logs */}
                {/* <Tab eventKey="2" title="Logs">
                  <div style={{ height: 440, overflowY: "auto" }}>
                    <Logs serialNumber={serialNumber} data={errors} />
                  </div>
                </Tab> */}

                {/* Aba dos Logs */}
                {/* <Tab eventKey="3" title="Estatística">
                  <div style={{ height: 440, overflowY: "auto" }}>
                    <Graphic serialNumber={serialNumber} data={errors} />
                  </div>
                </Tab> */}

              </Tabs>
            </div>
          </Col>
        </Row>
      </Card>
    </Page>
  );
};

export default ConectedOrange;


